var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128007(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021_OP_symbolikuvitus_128_007 1",
    clipPath: "url(#clip0_2204_5953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.9099 94.3701V102.27C74.9099 104.43 78.0999 106.18 82.0399 106.18C85.9799 106.18 89.1599 104.43 89.1599 102.27V94.3701",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.0399 97.3702C85.9722 97.3702 89.1599 95.924 89.1599 94.1402C89.1599 92.3563 85.9722 90.9102 82.0399 90.9102C78.1077 90.9102 74.9199 92.3563 74.9199 94.1402C74.9199 95.924 78.1077 97.3702 82.0399 97.3702Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M89.1599 98.5898C89.1599 100.38 85.9699 101.83 82.0399 101.83C78.1099 101.83 74.9099 100.38 74.9099 98.5898",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M101.06 104.96C104.545 104.96 107.37 103.147 107.37 100.91C107.37 98.6731 104.545 96.8599 101.06 96.8599C97.5751 96.8599 94.75 98.6731 94.75 100.91C94.75 103.147 97.5751 104.96 101.06 104.96Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40 60.2299V28.4199C40 27.8895 40.2107 27.3808 40.5858 27.0057C40.9609 26.6306 41.4696 26.4199 42 26.4199H114.8C115.33 26.4199 115.839 26.6306 116.214 27.0057C116.589 27.3808 116.8 27.8895 116.8 28.4199V80.7099C116.8 81.2404 116.589 81.7491 116.214 82.1241C115.839 82.4992 115.33 82.7099 114.8 82.7099H56.76",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.51 44.6999L40.04 43.1499",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M100.63 46.5098L78.44 51.0998L56.26 46.5098",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M116.84 43.1499L109.38 44.6999",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M56.26 40.4302H47.51V53.8202H56.26V40.4302Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M109.38 40.4302H100.63V53.8202H109.38V40.4302Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M67.3899 26.4101V18.1401H89.4899V26.4101",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M40 33.7799H43.5C44.5609 33.7799 45.5783 33.3585 46.3284 32.6084C47.0786 31.8582 47.5 30.8408 47.5 29.7799V26.9199",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M116.84 33.7799H113.35C112.289 33.7799 111.272 33.3585 110.522 32.6084C109.772 31.8582 109.35 30.8408 109.35 29.7799V26.9199",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M116.84 75.8599H113.35C112.289 75.8599 111.272 76.2813 110.522 77.0314C109.772 77.7816 109.35 78.799 109.35 79.8599V82.7399",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M17.2399 60.23C15.6265 60.2326 14.08 60.8754 12.9401 62.0172C11.8002 63.159 11.1599 64.7065 11.1599 66.32V71H23.3299",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M56.76 99.0699V83.8499V66.1899C56.7364 64.5922 56.0857 63.0677 54.9483 61.9452C53.8109 60.8228 52.278 60.1924 50.68 60.1899H17.24C18.0397 60.1899 18.8317 60.3475 19.5705 60.6535C20.3094 60.9596 20.9808 61.4082 21.5463 61.9737C22.1118 62.5392 22.5604 63.2105 22.8664 63.9494C23.1725 64.6883 23.33 65.4802 23.33 66.2799V86.2399V103.9C23.3536 105.498 24.0043 107.022 25.1417 108.145C26.279 109.267 27.812 109.897 29.41 109.9H62.84",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M62.8399 99.0698H35.4999V103.77C35.4999 104.57 35.3424 105.361 35.0363 106.1C34.7303 106.839 34.2817 107.511 33.7162 108.076C33.1507 108.642 32.4793 109.09 31.7405 109.396C31.0016 109.702 30.2097 109.86 29.4099 109.86H62.8399C63.6397 109.86 64.4316 109.702 65.1705 109.396C65.9093 109.09 66.5807 108.642 67.1462 108.076C67.7117 107.511 68.1603 106.839 68.4663 106.1C68.7724 105.361 68.9299 104.57 68.9299 103.77V99.0698H62.8399Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M29.53 71.02H50.56",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M29.53 78.1401H50.56",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M29.53 85.27H50.56",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M29.53 92.3901H50.56",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2204_5953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128007);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_007.3a78a3950c8b33868b2273adefa8bc7a.svg";
export { ForwardRef as ReactComponent };